var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',[_c('DocumentCategory',{attrs:{"id":90000}})],1),_c('v-col',[_c('DocumentCategory',{attrs:{"id":94000}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }